<div class="stats-revenue">
  <!-- KPI Summary -->
  <section class="stats-revenue__kpis">
    <app-kpi-card
      [title]="'STATISTICS.REVENUE.KPIS.TOTAL_REVENUE' | translate"
      [value]="revenueSummary?.totalRevenue?.value || 0"
      [previousValue]="revenueSummary?.totalRevenue?.previousValue"
      [trend]="revenueSummary?.totalRevenue?.trend"
      format="currency"
      icon="pi-wallet"
      iconColor="primary"
      [loading]="loadingKpis"
    />
    <app-kpi-card
      [title]="'STATISTICS.REVENUE.KPIS.TRANSACTIONS' | translate"
      [value]="revenueSummary?.transactions?.value || 0"
      [previousValue]="revenueSummary?.transactions?.previousValue"
      [trend]="revenueSummary?.transactions?.trend"
      format="number"
      icon="pi-shopping-cart"
      iconColor="info"
      [loading]="loadingKpis"
    />
    <app-kpi-card
      [title]="'STATISTICS.REVENUE.KPIS.AVERAGE_TICKET' | translate"
      [value]="revenueSummary?.averageTicket?.value || 0"
      [previousValue]="revenueSummary?.averageTicket?.previousValue"
      [trend]="revenueSummary?.averageTicket?.trend"
      format="currency"
      icon="pi-receipt"
      iconColor="success"
      [loading]="loadingKpis"
    />
  </section>

  <!-- Revenue Timeline Chart -->
  <section class="stats-revenue__chart-section">
    <div class="stats-revenue__card">
      <div class="stats-revenue__card-header">
        <h2>
          <i class="pi pi-chart-bar"></i>
          {{ "STATISTICS.REVENUE.CHARTS.BY_PERIOD" | translate }}
        </h2>
      </div>
      <div class="stats-revenue__card-body">
        <app-stat-chart
          type="bar"
          [data]="timelineChartData"
          [options]="timelineChartOptions"
          [loading]="loadingTimeline"
          [empty]="revenueTimeline.length === 0"
          height="300px"
        />
      </div>
    </div>
  </section>

  <!-- Two Column Section -->
  <section class="stats-revenue__two-col">
    <!-- By Category -->
    <div class="stats-revenue__card">
      <div class="stats-revenue__card-header">
        <h2>
          <i class="pi pi-tags"></i>
          {{ "STATISTICS.REVENUE.CHARTS.BY_CATEGORY" | translate }}
        </h2>
      </div>
      <div class="stats-revenue__card-body">
        <app-stat-chart
          type="bar"
          [data]="categoryChartData"
          [options]="categoryChartOptions"
          [loading]="loadingByCategory"
          [empty]="revenueByCategory.length === 0"
          height="220px"
        />
      </div>
    </div>

    <!-- By Payment Method -->
    <div class="stats-revenue__card">
      <div class="stats-revenue__card-header">
        <h2>
          <i class="pi pi-credit-card"></i>
          {{ "STATISTICS.REVENUE.CHARTS.BY_PAYMENT_METHOD" | translate }}
        </h2>
      </div>
      <div class="stats-revenue__card-body">
        <app-stat-chart
          type="bar"
          [data]="paymentChartData"
          [options]="paymentChartOptions"
          [loading]="loadingByPayment"
          [empty]="revenueByPayment.length === 0"
          height="180px"
        />
      </div>
    </div>
  </section>

  <!-- Revenue by Treatment Table -->
  <section class="stats-revenue__table-section">
    <div class="stats-revenue__card">
      <div class="stats-revenue__card-header">
        <h2>
          <i class="pi pi-list"></i>
          {{ "STATISTICS.REVENUE.TABLE.TITLE" | translate }}
        </h2>
      </div>
      <div
        class="stats-revenue__card-body stats-revenue__card-body--no-padding"
      >
        <p-table
          [value]="revenueByTreatment"
          [loading]="loadingByTreatment"
          styleClass="p-datatable-sm p-datatable-striped"
          [scrollable]="true"
          scrollHeight="400px"
          [rowHover]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="treatmentName">
                {{ "STATISTICS.REVENUE.TABLE.HEADERS.TREATMENT" | translate }}
                <p-sortIcon field="treatmentName" />
              </th>
              <th pSortableColumn="categoryName">
                {{ "STATISTICS.REVENUE.TABLE.HEADERS.CATEGORY" | translate }}
              </th>
              <th pSortableColumn="count" class="text-right">
                {{ "STATISTICS.REVENUE.TABLE.HEADERS.QUANTITY" | translate }}
              </th>
              <th pSortableColumn="averagePrice" class="text-right">
                {{ "STATISTICS.REVENUE.TABLE.HEADERS.AVERAGE_PRICE" | translate }}
              </th>
              <th pSortableColumn="revenue" class="text-right">
                {{ "STATISTICS.REVENUE.TABLE.HEADERS.REVENUE" | translate }}
              </th>
              <th class="text-center">
                <span
                  [pTooltip]="'STATISTICS.REVENUE.TABLE.TREND_TOOLTIP' | translate"
                  tooltipPosition="top"
                  class="trend-header"
                >
                  {{ "STATISTICS.REVENUE.TABLE.HEADERS.TREND" | translate }}
                  <i class="pi pi-info-circle"></i>
                </span>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <span class="treatment-name">{{ item.treatmentName }}</span>
              </td>
              <td>
                <span class="category-badge">{{ item.categoryName }}</span>
              </td>
              <td class="text-right">{{ item.count }}</td>
              <td class="text-right">
                {{ formatCurrency(item.averagePrice) }}
              </td>
              <td class="text-right font-semibold text-primary">
                {{ formatCurrency(item.revenue) }}
              </td>
              <td class="text-center">
                @if (item.trend !== undefined && item.trend !== null) {
                  <div class="trend-cell">
                    <span
                      class="trend-badge"
                      [ngClass]="'trend-badge--' + getTrendClass(item.trend)"
                    >
                      <i class="pi" [ngClass]="getTrendIcon(item.trend)"></i>
                      {{ item.trend * 100 | number: "1.1-1" }}%
                    </span>
                    @if (item.previousRevenue !== undefined) {
                      <span class="trend-detail">
                        {{
                          "STATISTICS.REVENUE.TABLE.TREND_VS"
                            | translate: { value: formatCurrency(item.previousRevenue) }
                        }}
                      </span>
                      @if (comparisonPeriod) {
                        <span class="trend-period">
                          {{ getComparisonPeriodLabel() }}
                        </span>
                      }
                    }
                  </div>
                } @else {
                  <span class="trend-na">—</span>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-muted">
                {{ "STATISTICS.REVENUE.TABLE.EMPTY" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </section>
</div>
